import { v4 as uuidv4 } from 'uuid';
import { getTelemetry } from '../../Telemetry/Telemetry';
import { ILogEntry } from './ILogEntry';
import { IBatchResponse } from '../models/IRegionalFormatPreference';

const telemetry = getTelemetry();
export class APITelemetry {
  private id: string;
  constructor() {
    this.id = '';
  }

  public startActivity(name: string, value: ILogEntry): void {
    this.id = uuidv4();
    const logEntry = {
      ...value,
      correlationId: this.id,
    };
    telemetry.reportCustomEvent('MyProfile.LanguageSettings.API.' + name + '.START', logEntry);
  }

  public stopActivity(name: string, result: ILogEntry): void {
    const logEntry = {
      ...result,
      correlationId: this.id,
    };
    telemetry.reportCustomEvent('MyProfile.LanguageSettings.API.' + name + '.STOP', logEntry);
  }

  public startBatchActivity(name: string, requests: { id: string }[]): void {
    this.id = uuidv4();
    requests.forEach((item) => {
      telemetry.reportCustomEvent('MyProfile.LanguageSettings.API.Batch.' + name + '.' + item.id + '.START', {
        id: item.id,
        correlationId: this.id,
      });
    });
  }

  public stopBatchActivity(name: string, num: string, result: IBatchResponse<any>): void {
    const logEntry = {
      ...result,
      correlationId: this.id,
    };

    telemetry.reportCustomEvent('MyProfile.LanguageSettings.API.Batch.' + name + '.' + num + '.STOP', logEntry);
  }
}
